export const prefillState = (filters) => {
  const data = {};
  filters.forEach(({ key, init }) => {
    data[key] = init;
  });
  return data;
};
